import { useAppDispatch } from "@/app/store/hooks";
import { FeedbackForm } from "@/features/feedbacks/ui/FeedbackForm";
import { SectionLayout } from "@/shared/ui/layouts/SectionLayout";
import Typography from "@/shared/ui/Typography";
import { complatedModalOpen } from "@/widgets/modal/model/slice";

export function ViewApplicationSection() {
    const dispatch = useAppDispatch();

    const handleSubmit = (name: string, phone: string) => {
        // send data logic
        console.log(name, phone);

        dispatch(complatedModalOpen());
    };

    return (
        <SectionLayout
            className="bg-light-blue"
            containerClassName="relative flex flex-col gap-[20px] md:gap-[32px] py-[40px]"
        >
            <div className="flex flex-col gap-[20px] md:gap-[28px]">
                <Typography tag="h2">запишитесь на просмотр</Typography>

                <Typography className="uppercase font-semibold text-[16px] md:text-[18px] !leading-[120%]">
                    Оставьте свои контакты, и мы подберём для вас эксклюзивные
                    варианты недвижимости
                </Typography>
            </div>

            <FeedbackForm 
                onSubmit={handleSubmit}
            />
        </SectionLayout>
    );
}
